"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _actions = require("./redux/actions");

var _RightRegion = _interopRequireDefault(require("./RightRegion"));

var _BottomRegion = _interopRequireDefault(require("./BottomRegion"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Menu = function Menu(_ref) {
  var index = _ref.index,
      id = _ref.id,
      collapsed = _ref.collapsed,
      _ref$collapsedRegions = _ref.collapsedRegions,
      collapsedRegions = _ref$collapsedRegions === void 0 ? [] : _ref$collapsedRegions,
      removeMenu = _ref.removeMenu,
      toggleCollapse = _ref.toggleCollapse;
  return (
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "Menu"
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "card mb-4"
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "card-header"
    },
    /*#__PURE__*/
    _react["default"].createElement("button", {
      className: "btn btn-sm btn-outline-secondary btn-icon mr-3 ".concat(collapsed ? 'collapsed' : ''),
      type: "button",
      onClick: function onClick() {
        return toggleCollapse('Menu', id);
      },
      "aria-expanded": "true",
      "aria-controls": "#menu-card-body-".concat(id)
    },
    /*#__PURE__*/
    _react["default"].createElement("i", {
      className: "material-icons"
    }, "expand_more")), "Menu ", index + 1,
    /*#__PURE__*/
    _react["default"].createElement("button", {
      className: "btn btn-sm btn-danger btn-icon ml-2 float-right",
      onClick: function onClick() {
        return removeMenu(id);
      },
      title: "Delete Menu"
    },
    /*#__PURE__*/
    _react["default"].createElement("i", {
      className: "material-icons"
    }, "delete_outline"))),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "card-body collapse ".concat(!collapsed ? 'show' : ''),
      id: "menu-card-body-".concat(id)
    },
    /*#__PURE__*/
    _react["default"].createElement(_RightRegion["default"], {
      id: id,
      collapsed: collapsedRegions.indexOf('right') > -1
    }),
    /*#__PURE__*/
    _react["default"].createElement(_BottomRegion["default"], {
      id: id,
      collapsed: collapsedRegions.indexOf('bottom') > -1
    }))))
  );
};

var _default = (0, _reactRedux.connect)(null, {
  removeMenu: _actions.removeMenu,
  toggleCollapse: _actions.toggleCollapse
})(Menu);

exports["default"] = _default;